import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionExpiredDialogComponent } from '@shared/components/session-expired-dialog/session-expired-dialog.component';
import { LanguageService } from '@services/languages/languages.service';

/**
 * Componente raíz de la aplicación.
 * Inicializa el servicio de idioma y provee el punto de montaje del router outlet principal.
 */
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SessionExpiredDialogComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

  private readonly _languageService = inject(LanguageService)

  /** Nombre de la aplicación. */
  title = 'gestion-riesgo-web';

  /** Inicializa el idioma de la aplicación al arrancar. */
  ngOnInit(): void {
    this._languageService.initializeLanguage()
  }
}
